import React from "react";
import {Button} from "antd";
import {useTranslation} from "react-i18next";
import {Language, VerticalLine, Wrapper} from "./LanguageSwitch.styles";

export const LanguageSwitch = () => {
    const {i18n} = useTranslation();
    const handleChangeLanguage = ({lng = "tr"}) => {
        i18n.changeLanguage(lng);
    };
    return (
        <Wrapper>
            <Language
                selected={i18n.resolvedLanguage !== "en"}
                onClick={() => handleChangeLanguage({lng: "tr"})}
            >
                TR
            </Language>
            <VerticalLine />
            <Language
                selected={i18n.resolvedLanguage === "en"}
                onClick={() => handleChangeLanguage({lng: "en"})}
            >
                EN
            </Language>
        </Wrapper>
    );
}; 
